import React, { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { Typography, Paper, Box } from "@mui/material";
import MyLogoLight from "../../vendor/ME_Light.png";
import InputOTP from "./input-otp/InputOTP";
import { useNavigate, useParams } from "react-router-dom";

const Brand = styled.img`
  fill: ${(props) => props.theme.palette.primary.main};
  display: block;
  margin: 0 auto;
  width: 256px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function ACTControl() {
  const { idUID } = useParams();
  const [data, setData] = useState([]);

  return (
    <React.Fragment>
      <Wrapper>
        <Brand src={MyLogoLight} />
        <Helmet title="ACT Control" />
        <Typography component="h1" variant="body1" align="center" gutterBottom>
          Ciao {data.nome}, è stata inviata un'email all'indirizzo {data.email}.
        </Typography>
        <Box display="flex" justifyContent="center" mt={4}>
          <InputOTP idUID={idUID} setData={setData} />
        </Box>
      </Wrapper>
    </React.Fragment>
  );
}

export default ACTControl;
